export const ANALYTIC_ID = "UA-185659622-1";
export const SHOW_MOBILE_APP_DOWNLOAD_BANNER = true;
export const IOS_APP_STORE_URL = "https://apps.apple.com/app/id1638661235";
export const ANDROID_PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=ventures.novum.stockhero";
export const REACT_APP_EXTERNAL_API_HOST = "https://external-api.stockhero.ai";

// --- Stage --- //
// export const STRIPE_ID = {
//   premium_monthly: "price_1LUoLvAlY9R4Wa1pW57ogfAf",
//   premium_quarterly: "price_1LUoLvAlY9R4Wa1pvUCJUKq8",
//   premium_yearly: "price_1LUoLvAlY9R4Wa1p63xnrDzq",
//   pro_monthly: "price_1LUoNVAlY9R4Wa1pasDLUkbq",
//   pro_quarterly: "price_1LUoNVAlY9R4Wa1prrRYzPlY",
//   pro_yearly: "price_1LUoNVAlY9R4Wa1poNKXsdh0",
//   lite_monthly: "price_1LUoKeAlY9R4Wa1pKWnFH3Pt",
//   lite_quarterly: "price_1LUoKeAlY9R4Wa1pjHhKUvSz",
//   lite_yearly: "price_1LUoKeAlY9R4Wa1pzJ3t9LGo",
// };
// export const STRIPE_PUBLIC =
//   "pk_test_51HWbXkAlY9R4Wa1pNNTATqAnlvpeeXyJ9I85E1B0QYUsIUPs84z84uQM9pVzm7hesVq2w6KQTmxu3tIXoEf0adRl0043MvXJnW";
// export const PAYPAL_CLIENT_ID =
//   "AZEKUKNsqMdEcNmSx3wT0RJfOaih0_Oj6Sa8MMWxY8ORons1bxN0pSovbeMYKAXtaK7hzjTivMwMmXXY";
// export const PAYPAL_ID = {
//   lite_monthly: "P-72J29231CS4680612ML7BARA",
//   lite_quarterly: "P-5M205282KR506954EML7BBEI",
//   lite_yearly: "P-4GF757066W302213UMMHP3GI",
//   premium_monthly: "P-76B0268383535172GMCXR7HQ",
//   premium_quarterly: "P-76B0268383535172GMCXR7HQ",
//   premium_yearly: "P-76B0268383535172GMCXR7HQ",
//   pro_monthly: "P-74U918610A5719342MCXR7TY",
//   pro_quarterly: "P-72J29231CS4680612ML7BARA",
//   pro_yearly: "P-52E196148S466304WMCXR74Y",
// };
// export const host = " https://api-stage.stockhero.ai/api";
// export const ws = "wss://api-stage.stockhero.ai";
// export const klineUrl = "https://api-stage.stockhero.ai/api/klines";



//--- Live --- //
export const STRIPE_ID = {
  premium_monthly: "price_1SuQsjAlY9R4Wa1pFTKFzArg",
  premium_quarterly: "price_1SuQv5AlY9R4Wa1pE35NpTgi",
  premium_yearly: "price_1SuQvYAlY9R4Wa1pqb1JjqFV",
  pro_monthly: "price_1SuQwsAlY9R4Wa1pn7ckoJu9",
  pro_quarterly: "price_1SuQz4AlY9R4Wa1pc470WsVd",
  pro_yearly: "price_1SuR6jAlY9R4Wa1pPBAgjPMb",
  lite_monthly: "price_1SuQg7AlY9R4Wa1psddY2jjH",
  lite_quarterly: "price_1SuQqdAlY9R4Wa1pYOflCkoS",
  lite_yearly: "price_1SuQqdAlY9R4Wa1pZNFioToK",
};

export const STRIPE_PUBLIC =
  "pk_live_51HWbXkAlY9R4Wa1pbPPwS6UJRtGLjM2s4EIN3N8ZLfZG4e5N7hDKbReLX3FRMmV5VjpoegfZJ3635q7GezMqX2ca00AygFxyo1";
export const PAYPAL_CLIENT_ID =
  "Aej4A5zdJZPIlZYmDHFawL9TMZxQcLQ-3kqnNGdX-eZxiUZIrTYcClH9JDbXd5g5tf9ZhqpEaZWi9s_0";

export const PAYPAL_ID = {
  lite_monthly: "P-79W582994W9211232NF42CQI",
  lite_quarterly: "P-5LF0523659881754UNF42DYQ",
  lite_yearly: "P-24175647LB6863947NF42EHI",
  premium_monthly: "P-74S20681FK4359442NF42FAI",
  premium_quarterly: "P-3AT253150Y125825BNF42FOI",
  premium_yearly: "P-76T14245048473254NF42FZQ",
  pro_monthly: "P-63Y481635D0879916NF42GKI",
  pro_quarterly: "P-413343355T160271HNF42GWI",
  pro_yearly: "P-31B571923F186335MNF42HEA",
};
export const host = "https://api.stockhero.ai/api";

export const ws = "wss://app-stage.stockhero.ai";
export const klineUrl = "https://api.stockhero.ai/api/klines";



// --- Local --- //
// export const STRIPE_ID = {
//   premium_monthly: "price_1LUoLvAlY9R4Wa1pW57ogfAf",
//   premium_quarterly: "price_1LUoLvAlY9R4Wa1pvUCJUKq8",
//   premium_yearly: "price_1LUoLvAlY9R4Wa1p63xnrDzq",
//   pro_monthly: "price_1LUoNVAlY9R4Wa1pasDLUkbq",
//   pro_quarterly: "price_1LUoNVAlY9R4Wa1prrRYzPlY",
//   pro_yearly: "price_1LUoNVAlY9R4Wa1poNKXsdh0",
//   lite_monthly: "price_1LUoKeAlY9R4Wa1pKWnFH3Pt",
//   lite_quarterly: "price_1LUoKeAlY9R4Wa1pjHhKUvSz",
//   lite_yearly: "price_1LUoKeAlY9R4Wa1pzJ3t9LGo",
// };
// export const STRIPE_PUBLIC =
//   "pk_test_51HWbXkAlY9R4Wa1pNNTATqAnlvpeeXyJ9I85E1B0QYUsIUPs84z84uQM9pVzm7hesVq2w6KQTmxu3tIXoEf0adRl0043MvXJnW";
// export const PAYPAL_CLIENT_ID =
//   "AQ58lfbo34MvYYhVOxBiLjziBQvAnOO5bN4JUdj9nxjiOKGkDn_03xqacAC8DWEj2vxCUh_8RSm6X_Pp";
// export const PAYPAL_ID = {
//   lite_monthly: "P-72J29231CS4680612ML7BARA",
//   lite_quarterly: "P-5M205282KR506954EML7BBEI",
//   lite_yearly: "P-4GF757066W302213UMMHP3GI",
//   premium_monthly: "P-76B0268383535172GMCXR7HQ",
//   premium_quarterly: "P-76B0268383535172GMCXR7HQ",
//   premium_yearly: "P-76B0268383535172GMCXR7HQ",
//   pro_monthly: "P-74U918610A5719342MCXR7TY",
//   pro_quarterly: "P-72J29231CS4680612ML7BARA",
//   pro_yearly: "P-52E196148S466304WMCXR74Y",
// };
// export const host = "https://stockhero-backend.test/api";
// export const ws = "wss://api-stage.stockhero.ai";
// export const klineUrl = "https://api-stage.stockhero.ai/api/klines";
